/* file description */
import React, { PropsWithChildren, useMemo } from 'react';
import useValuesStore from '@/store/useValuesStore';
import useMetaStore from '@/store/useMetaStore';
import _ from 'lodash';
import { ruleMapMatchExec, getValuesByRow } from '@/store/rulesCalc';
import { useAuth } from './useAuth';
import NoPermission from './NoPermission';

/**
 * 规则及权限控制器
 */
interface RuleControllerProps {
  /** 需要基于表达式计算的数据, 如果不传递，则使用stroe中全局数据 */
  data?: any;
  /** 对应 valueStore 中 rulesMap 的 cptKey */
  id?: string;
  /** 子节点 */
  children: any;
  /** 模型id，在行数据处理的时候，需要传入，去匹配生成用于计算的数据 */
  entityCode?: string;
  /** 行数据 */
  rowData?: any;
  /** 权限模型code */
  moduleCode?: string;
  /** 权限点控制 */
  ability?: string;
  /** 如果没有权限，是否显示无权限提示 */
  displayUnauthorizedInfo?: boolean;
}

export default function RuleController(props: RuleControllerProps) {
  const {
    data,
    id,
    children,
    entityCode,
    rowData,
    moduleCode,
    ability,
    displayUnauthorizedInfo,
  } = props;
  const { values, rulesMap } = useValuesStore();
  const { taskInfo, myRoles } = useMetaStore();

  // 权限处理
  const isAuthorized = useAuth({ moduleCode, ability });

  if (!isAuthorized) {
    if (displayUnauthorizedInfo) {
      return <NoPermission />;
    }
    return null;
  }

  // 如果在非Provider下使用，rulesMap为undefined
  if (!id || !rulesMap) {
    return children;
  }

  let calcValues = values;
  if (data) {
    calcValues = { ...values, ...data };
  }
  if (entityCode && rowData) {
    calcValues = getValuesByRow(entityCode, rowData, values, taskInfo?.relationTree);
  }

  const res = ruleMapMatchExec(rulesMap, id, calcValues, myRoles);

  if (res.visible === false) {
    return null;
  } else {
    return children;
  }
}
